import { createApp } from 'vue';
import MapLocation from '@components/MapLocation.vue';

const { address } = window.initialAppState.current_offer;

export const initMapLocation = () => {
  if (document.getElementById('static-google-map-app')) {
    createApp(MapLocation, {
      address,
    }).mount('#static-google-map-app');
  }
};
